import {
  ID_COUNTRY_LOCATION,
  MY_COUNTRY_LOCATION,
  SG_COUNTRY_LOCATION,
  VN_COUNTRY_LOCATION,
} from '../constants';

export const countryCodeIsVietnam = (countryCode?: string) =>
  countryCode?.toUpperCase() === VN_COUNTRY_LOCATION.code;

export const countryCodeIsIndonesia = (countryCode?: string) =>
  countryCode?.toUpperCase() === ID_COUNTRY_LOCATION.code;

export const countryCodeIsSingapore = (countryCode?: string) =>
  countryCode?.toUpperCase() === SG_COUNTRY_LOCATION.code;

export const countryCodeIsMalaysia = (countryCode?: string) =>
  countryCode?.toUpperCase() === MY_COUNTRY_LOCATION.code;
